// reducers/holidayReducer.js
export const holidayReducer = (state = { holidays: [] }, action) => {
  switch (action.type) {
    case "HOLIDAY_REQUEST":
      return { ...state, loading: true, error: null, success: false };

    case "GET_HOLIDAYS_SUCCESS":
      return { loading: false, holidays: action.payload };

    case "CREATE_HOLIDAY_SUCCESS":
      return {
        loading: false,
        success: true,
        holidays: [...state.holidays, action.payload],
      };

    case "UPDATE_HOLIDAY_SUCCESS":
      return {
        loading: false,
        success: true,
        holidays: state.holidays.map((h) =>
          h.id === action.payload.id ? action.payload : h,
        ),
      };

    case "DELETE_HOLIDAY_SUCCESS":
      return {
        loading: false,
        success: true,
        holidays: state.holidays.filter((h) => h.id !== action.payload),
      };

    case "HOLIDAY_NOTIFY_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        holidays: state.holidays.map((h) =>
          h.id === action.payload ? { ...h, notification_sent: true } : h,
        ),
      };

    case "SALARY_HOLIDAYS_SUCCESS":
      return { ...state, salaryHolidays: action.payload };

    case "HOLIDAY_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
